import type { ReactNode } from 'react';
import { Tooltip } from './tooltip';

interface InfoTooltipProps {
  message: ReactNode;
  label?: string;
}

/** Ícone de info que, ao clicar, mostra um balão explicativo. */
export function InfoTooltip({
  message,
  label = 'Mais informações',
}: InfoTooltipProps) {
  return (
    <Tooltip
      message={message}
      triggerLabel={label}
      triggerClassName="text-(--color-text-secondary) hover:text-(--color-text-primary) inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        className="h-5 w-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.25 11.25l.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>
    </Tooltip>
  );
}
